import React, { FC } from 'react';

import routePaths from 'config/routes';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import IconTextLink from 'src/components/scan/IconTextLink';
import { IRootReducers } from 'src/reducers';
import { IAction, IUser } from 'src/shared/models';
import {
  getProfileCompletedPoints,
  isProfileCompleted,
  useWindowSize,
} from 'utils';

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
    actions: state.app.actions,
  };
};

interface Props {
  title?: string;
  ctaBlocks: string[];
  user: IUser;
  actions: IAction[];
}

const PointsHowTo: FC<Props> = ({
  title = 'page.scan.page.title',
  ctaBlocks,
  user,
  actions,
}) => {
  const { isLG } = useWindowSize();
  const { formatMessage } = useIntl();

  const blockCustomClass = (index: number) => {
    if (ctaBlocks.length === 3 && index === 1) {
      return 'icon-text-link--center';
    }
  };

  return (
    <article className="points-how-to">
      <h2 className="points-how-to__title">{formatMessage({ id: title })}</h2>
      <div className="points-how-to__blocks">
        {ctaBlocks.map((block, index) => {
          switch (block) {
            case 'complete-profile':
              if (!isProfileCompleted(user?.actionList)) {
                return (
                  <IconTextLink
                    key={index}
                    customClass={blockCustomClass(index)}
                    icon="user"
                    text="page.scan.page.description.profile.incomplete"
                    value={{ points: getProfileCompletedPoints(actions) }}
                    link="page.scan.page.button.profile.incomplete"
                    linkUrl={routePaths.PAGES.MY_ACCOUNT.COMPLETE_PROFILE}
                    user={user}
                  />
                );
              }
              break;
            case 'scan-qr':
              return (
                <IconTextLink
                  key={index}
                  customClass={blockCustomClass(index)}
                  icon="qr-code"
                  text="page.scan.page.description"
                  qrScan={isLG}
                  user={user}
                />
              );
            case 'contest':
              return (
                <IconTextLink
                  key={index}
                  customClass={blockCustomClass(index)}
                  icon="diamond"
                  text="page.scan.page.description.contests"
                  link="page.scan.page.button.contests"
                  linkUrl={routePaths.PAGES.CHALLENGE}
                  user={user}
                />
              );
          }
        })}
      </div>
    </article>
  );
};

export default connect(mapStateToProps)(PointsHowTo);
